<template>
    <page>
        <div class="shadow-25 column items-center justify-center central-content">
            <v-header :title="$t('export file')" icon="cloud download"></v-header>
            <card width="400px" style="margin: 0 auto;">

                <form class="q-pt-xs gutter-xs row" method="post" target="_blank"
                :action="url">
                    <input type="hidden" name="partial" :value="partial">

                    <v-checkbox path="partial"
                                v-model="partial"
                                :label="$t('download only the lending points registered after the last export.')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>

                    <!-- Submit Button -->
                    <div class="row justify-center col-12 q-mt-md group">
                        <v-button :label="$t('download')"
                                  color="primary"
                                  class="no-shadow uppercase q-btn-iqos"
                                  type="submit">
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
        <q-modal v-model="infoModal" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header title="Guía de Importación" icon="info">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              @click="infoModalClose"/>
                </template>
            </v-header>
            <card width="100%">
                <p>En esta tabla de relaciones podrás encontrar información necesaria para colocar en los excel de importación.</p>
                <div v-if="infoContent">
                    <div v-for="(items, category) in infoContent" :key="category">
                    <h3>{{ category }}</h3>
                    <table>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Descripción</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.description || item.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <p v-else>No data available</p>
            </card>
        </div>
        </q-modal>
    </page>
</template>

<script>
    import { QModal } from 'quasar-framework'
    import {mapGetters} from "vuex";

    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('export file')}
        },

        components: {
            QModal
        },

        data() {
            return {
                config,
                partial: false,
                form: {},
            }
        },

        computed: {
            ...mapGetters({
                user: "auth/user",
            }),

            hasReverseFlowEnable() {
                if (!this.user) return false
                return this.user.market.configurations.some(config => {
                    return config.description === 'enable_reverse_flow' && parseInt(config.pivot.value) === 1
                })
            },

            url() {
                return this.hasReverseFlowEnable ? `${config.appUrl}/lending-point/export-with-reverse-flow` : `${config.appUrl}/lending-point/export`
            }
        },

        methods: {
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/markets/ES/pages/backoffice/lending-point/export.vue